import { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { useAppSelector } from '../../hooks';
import Panel from '../Panel/Panel';
import JPanel from '../UI/JPanel';
import { JButton } from '../UI/JButton';
import { toServer } from '../../util/ServerSocket';

export function Respawn() {
  const death = useAppSelector(state => state.character.death);
  const fight = useAppSelector(state => state.fight.fight);
  const coupons = useAppSelector(state => state.character.currency.giftCertificates);
  const vipExpiresAt = useAppSelector(state => state.character.vipExpiresAt ?? 0);
  const [now, setNow] = useState(Date.now());
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState('');
  const pending = useRef(false);
  useEffect(() => {
    if (!death || fight) return;
    toServer('startRespawnCooldown', null, (reply: any) => {
      if (reply?.error) setMessage(reply.error);
    });
  }, [!!death, !!fight]);
  useEffect(() => {
    setMessage('');
    setNow(Date.now());
    if (!death) return;
    const timer = window.setInterval(() => setNow(Date.now()), 250);
    return () => window.clearInterval(timer);
  }, [death?.availableAt]);
  if (!death || fight) return null;
  const seconds = death.cooldownStarted ? Math.max(0, Math.ceil((death.availableAt - now) / 2000)) : 30;
  const vip = vipExpiresAt > now;
  const cost = vip ? 50 : 100;
  function respawn(paid: boolean) {
    if (pending.current) return;
    pending.current = true;
    setBusy(true);
    setMessage('');
    const timeout = window.setTimeout(() => { pending.current = false; setBusy(false); setMessage('ไม่ได้รับคำตอบ กรุณาลองอีกครั้ง'); }, 10000);
    toServer('respawnCharacter', { paid }, (result: any) => {
      window.clearTimeout(timeout);
      pending.current = false;
      setBusy(false);
      if (!result?.success) setMessage(result?.error || 'เกิดใหม่ไม่สำเร็จ');
    });
  }
  return createPortal(
    <div role="dialog" aria-modal="true" aria-label="เกิดใหม่" style={{ position: 'fixed', inset: 0, zIndex: 31000, background: 'rgba(0,0,0,.55)' }}>
      <Panel name="เกิดใหม่" moveable={false} style={{ top: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: 31001 }}>
        <JPanel size={{ width: 430, height: 190 }}>
          <div style={{ padding: '16px 12px', textAlign: 'center', color: '#fff', lineHeight: '24px' }}>
            ตัวละครของคุณเสียชีวิต<br />
            เกิดใหม่ {cost} คูปอง: กลับหมู่บ้านพร้อม HP/MP 100%<br />
            {vip ? 'VIP เกิดฟรีได้ทันที' : `เกิดฟรี${seconds > 0 ? `ใน ${seconds} วินาที` : 'ได้แล้ว'}`}: กลับหมู่บ้านพร้อม HP/MP 30%
            {message && <div role="alert" style={{ color: '#ffd06a' }}>{message}</div>}
          </div>
          <JButton size={{ width: 175, height: 24 }} position={{ x: 25, y: 155 }} disabled={busy || coupons < cost} onClick={() => respawn(true)} text={`เกิดใหม่ ${cost} คูปอง`} />
          <JButton size={{ width: 175, height: 24 }} position={{ x: 230, y: 155 }} disabled={busy || (!vip && (!death.cooldownStarted || seconds > 0))} onClick={() => respawn(false)} text={vip ? 'เกิดฟรีทันที (VIP)' : seconds > 0 ? `เกิดฟรี (${seconds})` : 'เกิดฟรี'} />
        </JPanel>
      </Panel>
    </div>, document.body);
}
